import { AnalysisListDTO } from "@models/platform-analysis/entities/analysis";
import { APIExtRoutes } from "@constants";
import { SHSnackbarOptions } from "@hooks/useNotification";

export class AnalysisConfigs {
  // Routes
  static readonly DefaultODataRoute = APIExtRoutes.odataPlatformAnalysis;

  // Table data
  static readonly SupplierPickColumns: (keyof AnalysisListDTO)[] = [
    "id",
    "name",
    "ownerName",
    "ownerAvatarUrl",
    "adviserName",
    "includeSteps",
    "dataValidDate",
    "lastModifiedDate",
    "status",
  ];
  static readonly SupplierGlobalFilterColumns: (keyof AnalysisListDTO)[] = [
    "name",
    "ownerName",
    "adviserName",
  ];

  static readonly AdviserPickColumns: (keyof AnalysisListDTO)[] = [
    "id",
    "name",
    "ownerName",
    "ownerAvatarUrl",
    "familyGroupName",
    "dataValidDate",
    "lastModifiedDate",
    "status",
  ];
  static readonly AdviserGlobalFilterColumns: (keyof AnalysisListDTO)[] = [
    "name",
    "familyGroupName",
    "ownerName",
  ];

  // Styles
  static readonly DefaultFontSize: number = 13;
  static readonly DefaultSnackbarOptions: SHSnackbarOptions = {
    variant: "error",
    close: true,
    width: 580,
    key: "edit",
  };
}
